import { MutableRefObject } from 'react'
import { useDocumentEventListener } from './useDocumentEventListener'

export function useOnOutsideClick(elementRef: MutableRefObject<Node | null>, callback: () => void, condition = true) {
  const fn = (event: Event) => event.target instanceof Node && !elementRef.current?.contains(event.target) && callback()

  useDocumentEventListener('mousedown', fn, condition)
  useDocumentEventListener('touchstart', fn, condition)
}
